module.exports = __webpack_public_path__ + "static/media/gymet_1.fdfd6dcc.png";